import { type Alert, addDays, computeMetrics, fmtShort, localToday, type Task } from '@quadro/domain';
import { Icon } from '../../components/Icon';
import { useUI } from '../../state/ui';
import { useWorkspace } from '../../state/workspace';

const LEVEL: Record<Alert['level'], string> = { red: 'var(--red)', orange: 'var(--orange)', yellow: 'var(--yellow)', purple: 'var(--purple)' };

/** Pontos de atenção (clicáveis, destacam cartões) e ritmo da equipe. */
export function InsightsPanel({ alerts, tasks }: { alerts: Alert[]; tasks: Task[] }) {
  const ws = useWorkspace();
  const { highlight, set } = useUI();
  const today = localToday();
  const m = computeMetrics(tasks, today);
  const max = Math.max(1, ...m.perDay);
  const wip = ws.settings.wipLimit;
  return (
    <aside className="insights" aria-label="Pontos de atenção">
      <h2>Atenção <button className="x-btn" onClick={() => set({ insights: false })} aria-label="Fechar painel"><Icon name="x" /></button></h2>
      <p>Clique para destacar os cartões envolvidos.</p>
      {alerts.length
        ? alerts.map(a => (
            <button key={a.id} className="alert" style={{ '--lv': LEVEL[a.level] } as React.CSSProperties} aria-pressed={highlight === a.id}
              onClick={() => set({ highlight: highlight === a.id ? null : a.id })}>
              <i className="lv" /><div><strong>{a.title}</strong><span>{a.description}</span></div>
            </button>
          ))
        : <div className="allgood">Nada pedindo atenção agora.</div>}
      <div className="divider" />
      <h2>Ritmo</h2>
      <div className="tiles">
        <div className="tile"><b>{m.doneLast7}</b><span>finalizadas em 7 dias</span></div>
        <div className="tile"><b>{m.avgCycleDays === null ? '–' : m.avgCycleDays.toFixed(1).replace('.', ',')}</b><span>dias de ciclo médio</span></div>
        <div className="tile"><b style={m.doing > wip ? { color: 'var(--red)' } : undefined}>{m.doing}</b><span>em andamento, limite {wip}</span></div>
        <div className="tile"><b>{m.waiting}</b><span>aguardando terceiros</span></div>
      </div>
      <div className="spark">
        <p>Entregas por dia, últimas 2 semanas</p>
        <svg viewBox="0 0 280 54" preserveAspectRatio="none" role="img" aria-label="Gráfico de entregas por dia">
          {m.perDay.map((v, i) => (
            <rect key={i} x={i * 20 + 3} y={52 - (v / max) * 46} width={12} height={Math.max(2, (v / max) * 46)} rx={2} fill={i === 13 ? 'var(--blue)' : 'var(--label3)'}>
              <title>{fmtShort(addDays(today, i - 13))}: {v}</title>
            </rect>
          ))}
        </svg>
        <div className="axis"><span>{fmtShort(addDays(today, -13))}</span><span>hoje</span></div>
      </div>
    </aside>
  );
}
